<template>
  <v-flex>
    <!-- Formulario para crear o editar una etapa -->
    <v-dialog v-if="this.modelEtapa" v-model="dialogFormularioEtapa" :max-width="1400" persistent>
      <etapa-formulario @cerrarFormularioEtapa="_cerrarUpdateFormularioEtapa"
        @soloCerrar="dialogFormularioEtapa = false" :modelEtapa="this.modelEtapa" :accion="this.accionEtapa"
        :camino="this.modelCamino" />
    </v-dialog>


    <v-card :color="'rgb(250, 250, 250)'" class="elevation-0 mb-4">
      <v-toolbar dense :color="colorBarraFormulario" dark flat>
        <v-toolbar-title v-bind:style="{ color: colorFondoDialog }">
          <span v-bind:style="{ color: 'white' }">Camino</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-chip class="mr-4 px-10" label :color="colorAccent1" text-color="white" link @click="_guardarCamino(false)">
          <span v-if="loading" v-bind:style="{ color: 'white' }">Guardando...</span>
          <span v-else v-bind:style="{ color: 'white' }">Guardar</span>
        </v-chip>
        <v-chip class="mr-4 px-10" label :color="colorAccent1" text-color="white" link @click="_guardarCamino(true)">
          <span v-if="loading" v-bind:style="{ color: 'white' }">Guardando...</span>
          <span v-else v-bind:style="{ color: 'white' }">Guardar y Cerrar</span>
        </v-chip>
        <v-icon size="30" :color="'white'" @click="_cerrarVentana">mdi-close-circle</v-icon>
      </v-toolbar>
      <v-card-text>
        <v-row class="mt-6" dense>
          <v-col cols="7" class="ml-0">

            <v-card class="mx-4">
              <v-card-title>
                <v-tabs v-model="tab" grow>
                  <v-tab v-for="(language, index) in languages" :key="index">
                    {{ language }}
                  </v-tab>
                </v-tabs>
              </v-card-title>

              <v-card-text>
                <v-tabs-items v-model="tab">
                  <v-tab-item>
                    <v-card>
                      <v-card-text>
                        <v-row dense class="mx-4">
                          <v-text-field v-model="modelCamino.titulo" outlined label="Nombre" dense :dark="dark"
                            autocomplete="off"></v-text-field>
                        </v-row>

                        <v-row dense class="mx-4">
                          <v-text-field outlined dense :dark="dark" autocomplete="off" v-model="modelCamino.subtitulo"
                            label="Subtitulo"></v-text-field>
                        </v-row>

                        <v-row dense class="mx-4">
                          <v-textarea rows="10" outlined v-model="modelCamino.resumen" :dark="dark"
                            label="Resumen"></v-textarea>
                        </v-row>

                        <v-row dense class="mx-4">
                          <v-textarea rows="20" outlined v-model="modelCamino.descripcion" :dark="dark"
                            label="Descripcion"></v-textarea>
                        </v-row>


                      </v-card-text>
                    </v-card>
                  </v-tab-item>

                  <v-tab-item>
                    <v-card>
                      <v-card-text>
                        <v-row dense class="mx-4">
                          <v-text-field v-model="modelCamino.titulo_EN" outlined label="Nombre" dense :dark="dark"
                            autocomplete="off"></v-text-field>
                        </v-row>

                        <v-row dense class="mx-4">
                          <v-text-field outlined dense :dark="dark" autocomplete="off"
                            v-model="modelCamino.subtitulo_EN" label="Subtitulo"></v-text-field>
                        </v-row>

                        <v-row dense class="mx-4">
                          <v-textarea rows="10" outlined v-model="modelCamino.resumen_EN" :dark="dark"
                            label="Resumen"></v-textarea>
                        </v-row>

                        <v-row dense class="mx-4">
                          <v-textarea rows="20" outlined v-model="modelCamino.descripcion_EN" :dark="dark"
                            label="Descripcion"></v-textarea>
                        </v-row>


                      </v-card-text>
                    </v-card>
                  </v-tab-item>

                  <v-tab-item>
                    <v-card>
                      <v-card-text>
                        <v-row dense class="mx-4">
                          <v-text-field v-model="modelCamino.titulo_DE" outlined label="Nombre" dense :dark="dark"
                            autocomplete="off"></v-text-field>
                        </v-row>

                        <v-row dense class="mx-4">
                          <v-text-field outlined dense :dark="dark" autocomplete="off"
                            v-model="modelCamino.subtitulo_DE" label="Subtitulo"></v-text-field>
                        </v-row>

                        <v-row dense class="mx-4">
                          <v-textarea rows="10" outlined v-model="modelCamino.resumen_DE" :dark="dark"
                            label="Resumen"></v-textarea>
                        </v-row>

                        <v-row dense class="mx-4">
                          <v-textarea rows="20" outlined v-model="modelCamino.descripcion_DE" :dark="dark"
                            label="Descripcion"></v-textarea>
                        </v-row>


                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                </v-tabs-items>
              </v-card-text>
            </v-card>
          </v-col>



          <v-divider vertical></v-divider>

          <v-col class="ml-2">
            <v-card class="mb-6" color="rgb(250, 250, 250)">
              <v-toolbar :dark="!dark" dense color="rgb(120, 130, 120)" flat>
                <v-chip label class="mr-1" color="rgb(60, 60, 60)">
                  <span v-bind:style="{ color: 'white' }">
                    {{ modelCamino.etapas.length }}
                  </span>
                </v-chip>
                <v-divider class="mx-2" inset vertical></v-divider>
                <v-toolbar-title :dark="!dark">Etapas</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-chip label class="mr-2" link :color="colorAccent1" @click="_crearEtapa">
                  <span v-bind:style="{ color: 'white' }">
                    Nueva Etapa
                  </span>
                </v-chip>
              </v-toolbar>

              <v-card-text>

                <v-card class="mb-1 elevation-0" v-for="etapa in modelCamino.etapas" :key="etapa.id"
                  color="rgb(230, 230, 230)">
                  <v-card-title>
                    <div v-if="etapa.imagen_base64" class="mr-4">
                        <img :src="etapa.imagen_base64" alt="Imagen de Etapa" width="40" height="40" style="border-radius: 10%;" />
                    </div>
                    <div v-else class="mr-4" style="width: 40px; height: 40px; background-color: white; border-radius: 10%;"></div>

                    <h5>
                      {{ etapa.titulo }}
                    </h5>
                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-chip label class="mr-1 px-1" link :color="colorAccent3" @click="_editarEtapa(etapa)"
                          v-on="on">
                          <v-icon color="white">mdi-pencil</v-icon>
                        </v-chip>
                      </template>
                      <span>Editar Etapa</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-chip label class="mr-1 px-1" link color="red lighten-2" @click="_deleteEtapa(etapa)"
                          v-on="on">
                          <v-icon color="white">mdi-delete</v-icon>
                        </v-chip>
                      </template>
                      <span>Eliminar Etapa</span>
                    </v-tooltip>
                  </v-card-title>
                  <v-divider></v-divider>
                </v-card>
              </v-card-text>
            </v-card>

            <v-row dense class="mx-4 mt-16">
              <v-select outlined dense :dark="dark" autocomplete="off" v-model="modelCamino.dificultad"
                label="Dificultad" :items="dificultades"></v-select>
            </v-row>

            <v-row dense class="mx-4">
              <v-text-field outlined dense :dark="dark" autocomplete="off" v-model="modelCamino.distancia"
                label="Distancia"></v-text-field>
            </v-row>

            <v-row dense class="mx-4">
              <v-text-field outlined dense type="number" :dark="dark" autocomplete="off" v-model="modelCamino.noches"
                label="Noches"></v-text-field>
            </v-row>

            <v-row dense class="mx-4">
              <v-text-field outlined dense :dark="dark" autocomplete="off" v-model="modelCamino.precio_ind"
                label="Precio Individual"></v-text-field>
            </v-row>

            <v-row dense class="mx-4">
              <v-text-field outlined dense :dark="dark" autocomplete="off" v-model="modelCamino.precio_doble"
                label="Precio Doble"></v-text-field>
            </v-row>

            <v-row dense class="mx-4">
              <v-text-field outlined dense :dark="dark" autocomplete="off" v-model="modelCamino.precio_triple"
                label="Precio Triple"></v-text-field>
            </v-row>

            <v-row dense class="mx-4">
              <v-text-field outlined dense :dark="dark" autocomplete="off" v-model="modelCamino.suplemento"
                label="Suplemento (%) para Julio y Agosto"></v-text-field>
            </v-row>
          </v-col>

        </v-row>


      </v-card-text>
    </v-card>
  </v-flex>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import EtapaFormulario from "@/components/formularios/EtapaFormulario.vue";

export default {
  name: "CaminoFormulario",
  components: {
    EtapaFormulario,
  },
  data: () => ({
    loading: false,

    modelEtapa: null,
    accionEtapa: "",
    dialogFormularioEtapa: false,
    showConfirmacionEliminacionEtapa: false,

    tab: null, // Para controlar el tab activo
    languages: ['Español', 'Inglés', 'Alemán'], // Nombres de los idiomas


  }),

  props: {
    modelCamino: {
      type: Object,
      required: true,
    },

    accion: {
      type: String,
      required: true,
    },
  },

  computed: {
    ...mapState([
      "drawer",
      "dark",
      "colorAccent1",
      "colorAccent2",
      "colorAccent3",
      "colorBarraFormulario",
      "colorFondoDialog",
      "dificultades",

    ]),
    ...mapState("auth", [
      "user",
      "date",
      "access_token",
      "error",
      "errorMessage",
    ]),
    ...mapState("etapas", ["etapas", "etapaSelec"]),
  },


  mounted() {

  },

  methods: {
    ...mapActions("caminos", ["getCaminos", "crearCamino", "updateCamino"]),
    ...mapMutations("etapas", ["setEtapaSelec"]),

    _cerrarVentana() {
      this.$emit("cerrarFormularioCamino");
    },

    _cerrarUpdateFormularioEtapa(etapa) {
      if (etapa != null) {
        if (this.accionEtapa == "crear") {
          this.modelCamino.etapas.push(etapa);
        } else if (this.accionEtapa == "editar") {
          let index = this.modelCamino.etapas.findIndex((e) => e.id == etapa.id);
          this.modelCamino.etapas[index] = etapa;
        }
      }
      this.dialogFormularioEtapa = false;

    },

    async _guardarCamino(cerrar) {
      this.loading = true;
      if (this.accion == "crear") {
        var res = await this.crearCamino([
          this.access_token,
          this.modelCamino,
        ]);
        const params = {};
        await this.getCaminos([this.access_token, false]);
      } else if (this.accion == "editar") {
        var res = await this.updateCamino([
          this.access_token,
          this.modelCamino,
        ]);
      }
      if (cerrar) {
        this._cerrarVentana();
      }
      this.loading = false;
    },

    _crearEtapa() {
      this._inicializarModelEtapa();
      this.accionEtapa = 'crear';
      this.dialogFormularioEtapa = true;
    },

    _inicializarModelEtapa() {
      this.modelEtapa = {
        id: null,
        titulo: null,
        descripcion: null,
        inicio_punto: null,
        final_punto: null,
        dificultad: null,
        duracion: null,
        distancia: null,
        imagen_base64: null,
      };
    },

    _editarEtapa(item) {
      this.setEtapaSelec(item);
      let temp = JSON.parse(JSON.stringify(this.etapaSelec));
      this.modelEtapa = temp;
      this.accionEtapa = 'editar';
      console.log("modelEtapa:", this.modelEtapa);
      this.dialogFormularioEtapa = true;
    },

    _deleteEtapa(etapa) {
    },
  },
};
</script>
